export const initialState = {
  loadingStatus: {
    timeSlotLoading: false,
    holdBookingSlotLoading: false,
    releaseBookingSlotLoading: false,
    bookAppointmentLoading: false,
    saveSelectedBookingSlotLoading: false,
    clearSelectedBookingSlotLoading: false,
    bookingDetailLoading: false,
    bookingListLoading: false,
  },
  timeSlotData: {},
  bookingDetail: {},
  currentHoldingSlot: {},
  selectedBookingSlot: {},
  bookingList: {
    data: [],
    offset: 0,
    limit: 0,
    total: 0,
  },

  error: '',
};
